import AddCommentIcon from "@mui/icons-material/AddComment";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Skeleton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import moment from "moment";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CustomIcon from "../../../components/customIcon";
import AddFamilyMember from "../../../components/modals/addFamilyMember";
import HufHeadAndTrust from "../../../components/modals/HufHeadAndTrust";
import AreYouSureModal from "../../../components/modals/areYouSureModal";
import EditProfileModal from "../../../components/modals/editProfileModal";
import SecondaryBlockchainAccountModal from "../../../components/modals/secondaryBlockchainAccount";
import Tabs from "../../../components/tabs/tabs";
import { saveUser } from "../../../redux/reducers/userSlice";
import store from "../../../redux/store";
import authServices from "../../../services/authServices";
import familymemberServices from "../../../services/familymemberServices";
import userServices from "../../../services/userServices";
import FamilyMemberProfile from "./FamilyMember/familymemberProfile";
import HufProfile from "./Huf/HufProfile";
import trustServices from "../../../services/trustServise";
import TrustProfile from "./Trust/TrustProfile";
import { BankAccount } from "../../../components/bankAccount";
import { getAccountLink, getExplorerButtonText } from "../../../utils/blockchainExplorer";
import { loggout } from "../../../utils/functions";

export default function MyProfile() {
  const location = useLocation();

  const investorId = useSelector(state => state.user.data?._id);
  const [hufHeadDetails, setHufHeadDetails] = useState([]);
  const [trustDetails, setTrustDetails] = useState([]);
  const [familyMemberDetail, setFamilymemberDetail] = useState([]);
  const [url, setUrl] = useState("");
  const getHufDetails = async () => {
    try {
      const res = await userServices.getHufDetails(investorId);
      if (res && res.success) {
        setHufHeadDetails(res.data);
        setUrl(res.url);
      }
    } catch (error) {
      console.log("Error fetching HUF details:", error);
    }
  };

  const getTrustDetails = async () => {
    try {
      const res = await trustServices.getTrustDetails(investorId);
      if (res && res.success) {
        setTrustDetails(res.data);
        setUrl(res.url);
      }
    } catch (error) {
      console.log("Error fetching Trust details:", error);
    }
  };

  const getallFamilyMember = async () => {
    try {
      const res = await familymemberServices.familyMemberAccordingToInvester(
        investorId
      );
      if (res && res.success) {
        setFamilymemberDetail(res.data);
        // setUrl(res.url)
      }
    } catch (error) {
      console.log("Error fetching HUF details:", error);
    }
  };

  useEffect(() => {
    if (investorId) {
      getallFamilyMember();
      getHufDetails();
      getTrustDetails();
    }
  }, [investorId]);

  const tabs = [
    {
      name: "Personal Profile",
      tab: (
        <PersonalProfile
          hufHeadDetails={hufHeadDetails}
          familyMemberDetail={familyMemberDetail}
          getallFamilyMember={getallFamilyMember}
          trustDetails={trustDetails}
        />
      ),
    },
    ...(hufHeadDetails.length > 0
      ? [
          {
            name: "HUF Profile",
            tab: (
              <HufProfile
                hufHeadDetails={hufHeadDetails}
                url={url}
                getHufDetails={() => getHufDetails()}
              />
            ),
          },
        ]
      : []),
    ...(familyMemberDetail.length > 0
      ? [
          {
            name: "Family Member",
            tab: (
              <FamilyMemberProfile
                fmailyMemberDetail={familyMemberDetail}
                url={url}
                getallFamilyMember={getallFamilyMember}
              />
            ),
          },
        ]
      : []),
    ...(trustDetails.length > 0
      ? [
          {
            name: "Trust",
            tab: (
              <TrustProfile
                trustDetails={trustDetails}
                url={url}
                getTrustDetails={() => getTrustDetails()}
              />
            ),
          },
        ]
      : []),
  ];

  const [activeTab, setActiveTab] = useState(0);

  const [showSignUp, setShowSignUp] = useState(false);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");

    if (tab && tabs[parseInt(tab, 10)]) {
      setActiveTab(parseInt(tab, 10));
    }
  }, [hufHeadDetails]);

  useEffect(() => {
    // const params= new URLSearchParams(location.search);
    // const tab= params.get('tab')
  }, [hufHeadDetails]);

  const customHandleClose = () => {
    setShowSignUp(!showSignUp);
  };

  return (
    <Card sx={{ mt: { md: 2, xs: 1 } }}>
      <CardContent>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          sx={{
            pb: "10px",
            pl: { md: 0, xs: 0 },
          }}
        >
          <Tabs activeTab={activeTab} tabs={tabs} onClick={handleTabClick} />
        </Stack>
        <Divider
          sx={{
            width: "calc(100% + 80px)",
            mx: -5,
          }}
        />
        <Grid
          container
          columnGap={2}
          rowSpacing={1}
          mt={{ md: 1, xs: 1 }}
          sx={{
            backgroundColor: "#f7f7f7",
            paddingBottom: 3,
            flexDirection: "column",
          }}
        >
          {tabs[activeTab]?.tab}
          <Box sx={{ marginLeft: "10px" }}></Box>
        </Grid>
        <Divider
          sx={{
            width: "calc(100% + 80px)",
            mx: -5,
            marginTop: "10px",
            marginBottom: "10px",
          }}
        />
      </CardContent>
    </Card>
  );
}

function PersonalProfile({
  hufHeadDetails,
  familyMemberDetail,
  getallFamilyMember,
  trustDetails,
}) {
  const user = useSelector((state) => state.user.data);
  const [isEditing, setIsEditing] = useState(false);
  const [isBankEditing, setIsBankEditing] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const dispatch = useDispatch();

  const handleLogout = () => {
    try {
      loggout();
      enqueueSnackbar("Logged out successfully", { variant: "success" });
    } finally {
      navigate("/", { replace: true });
    }
  };

  const [availableBlockchainAccounts, setAvailableBlockchainAccounts] = useState([]);
  const [availablePolygonBlockchainAccounts, setAvailablePolygonBlockchainAccounts] = useState([]);
  const [availableMstBlockchainAccounts, setAvailableMstBlockchainAccounts] = useState([]);
  const [availableBankAccounts, setAvailableBankAccounts] = useState([])
  const [blockchainAccountModal, setBlockchainAccountModal] = useState(false);
  const [usernameError, setUsernameError] = useState(false);
  const [showTrustQues, setShowTrustQues] = useState(false);
  const [showHufQues, setShowHufQues] = useState(false);
  const [createFamilyMember, setCreateFamilyMember] = useState(false);
  const [showEditProfile, setShowEditProfile] = useState(false);
  const [profileSectionsExpanded, setProfileSectionsExpanded] = useState({
    personal: true,
    address: true,
  });

  useEffect(() => {
    fetchDltWallet();
    setAvailableBankAccounts(user?.bankAccount);
  }, [user]);

  const fetchDltWallet = async () => {
    let dltWallet = await userServices.getDltWallet(user._id,"algorand")
    setAvailableBlockchainAccounts(dltWallet.data)
    let polygonDltWallet = await userServices.getDltWallet(user?._id , "polygon");
    let mstDltWallet = await userServices.getDltWallet(user?._id , "mst")
    setAvailablePolygonBlockchainAccounts(polygonDltWallet.data)
    setAvailableMstBlockchainAccounts(mstDltWallet.data)
  }

  const handleHufClose = () => {
    setShowHufQues(false);
  };
  const handleTrustClose = () => {
    setShowTrustQues(false);
  };
  const handleCreateFamilyMember = () => {
    setCreateFamilyMember(false);
  };

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));


  const TypographyText = ({ label, value, isRow = false }) => {
    return (
      <Stack
        direction={isRow ? "row" : { md: "column", xs: "row" }}
        spacing={1}
        justifyContent={
          isRow ? "space-between" : { xs: "space-between", md: "start" }
        }
        sx={{
          width: "100%",
          wordWrap: "break-word",
          overflowWrap: "break-word",
        }}
      >
        <Typography variant="label">{label}</Typography>
        <Typography
          variant="body3"
          sx={{
            wordWrap: "break-word",
            overflowWrap: "break-word",
            whiteSpace: "normal",
            overflow: "hidden",
          }}
        >
          {value}
        </Typography>
      </Stack>
    );
  };

  const handleProfileClose = () => {
    setShowEditProfile(false);
  };

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const isEntitymenuDisabled =
    hufHeadDetails.length > 0 &&
    familyMemberDetail.length > 1 &&
    trustDetails.length > 0;

  return (
    <>
      <EditProfileModal
        user={user}
        open={showEditProfile}
        handleClose={handleProfileClose}
        dispatch={dispatch}
      />
      <HufHeadAndTrust open={showHufQues} handleClose={handleHufClose} />
      <HufHeadAndTrust open={showTrustQues} handleClose={handleTrustClose} />
      <AddFamilyMember
        open={createFamilyMember}
        handleClose={handleCreateFamilyMember}
        getallFamilyMember={getallFamilyMember}
      />
      <Stack
        width={{ md: "80%", xs: "100%" }}
        direction="row" 
        alignItems="center"
        justifyContent="space-between"
        my={2}
        mx={{ md: "auto", xs: 0 }}
        px={{ md: "40px", xs: "5px" }}
        rowGap={{ xs: 1, sm: 0 }}
      >
        <Typography variant="mainCardTitle">My Profile</Typography>

        <Stack
          direction={"row"}
          columnGap={1}
          rowGap={1}
          flexWrap="wrap"
          width="auto"
        >
          {/* {user?.status === "APPROVED" && user?.citizenShip === "INDIAN" && hufHeadDetails.length === 0 && <Button variant="outlined" size="small" onClick={() => setShowHufQues(true)}>Create an HUF</Button>}
          {user?.status === "APPROVED" && user?.citizenShip === "INDIAN" && familyMemberDetail.length === 0 && <Button variant="outlined" size="small" onClick={() => setCreateFamilyMember(true)}>Add Family member</Button>} */}
          <Stack direction="row" spacing={2}></Stack>

          <Button
            variant="outlined"
            color="primary"
            size="small"
            sx={{ padding: { sm: "10px 12px !important", xs: "5px 10px !important" } }}
            onClick={() => {
              setShowEditProfile(true);
            }}
          >
            Edit Profile
          </Button>
          <EntityMenu
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            getallFamilyMember={getallFamilyMember}
            familyMemberDetail={familyMemberDetail}
            hufHeadDetails={hufHeadDetails}
            trustDetails={trustDetails}
          />
          {user?.status === "APPROVED" && user?.citizenShip === "INDIAN" && (
            <Button
              disabled={isEntitymenuDisabled}
              variant="contained"
              size="small"
              sx={{ cursor: "pointer" }}
              startIcon={<AddCommentIcon />}
              onClick={openMenu}
            >
              Add Entity
            </Button>
          )}
        </Stack>
      </Stack>

      <SecondaryBlockchainAccountModal
        open={blockchainAccountModal}
        setOpen={setBlockchainAccountModal}
        fetchDltWallet={fetchDltWallet}
        user={user}
        dispatch={dispatch}
        disableAlgorandOption = {true}
        disablePolygonOption = {availablePolygonBlockchainAccounts?.length >= 5}
        disableMstOption = {availableMstBlockchainAccounts?.length >= 5}
      />

      {user ? (
        <Stack
          spacing={2}
          sx={{ m: "0px auto", width: { sm: "80%", xs: "100%" } }}
        >
          {isSmallScreen ? (
            <Accordion
              expanded={profileSectionsExpanded.personal}
              onChange={(_, expanded) =>
                setProfileSectionsExpanded((prev) => ({ ...prev, personal: expanded }))
              }
              sx={{ m: "12px auto", borderRadius: 2, overflow: "hidden" }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="headerMenu">Personal Info</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ pt: 0 }}>
                <Divider sx={{ width: "100%", mb: 1 }} />
                <Stack rowGap={{ md: 4, xs: "4px" }}>
                  <Stack
                    direction={{ md: "row", xs: "column" }}
                    rowGap={{ xs: "4px", md: 0 }}
                    columnGap={4}
                  >
                    <TypographyText label="User Name" value={user.username} />
                    <TypographyText label="legal Name" value={user?.legalName} />
                    <TypographyText label="Mobile Number" value={user.mobileNumber} />
                  </Stack>
                  <Stack
                    direction={{ md: "row", xs: "column" }}
                    rowGap={{ xs: "4px", md: 0 }}
                    columnGap={4}
                  >
                    <TypographyText label="Email" value={user.emailId} />
                    <TypographyText
                      label="Date Of Birth"
                      value={moment.unix(user.dob).format("DD-MM-YYYY")}
                    />
                    <TypographyText label="Citizenship" value={user.citizenShip} />
                  </Stack>
                </Stack>
              </AccordionDetails>
            </Accordion>
          ) : (
            <Card sx={{ m: "12px auto" }}>
              <CardContent sx={{ p: "0px !important" }}>
                <Stack direction={{ md: "row", xs: "column" }} spacing={2}>
                  <Stack
                    sx={{
                      width: { md: "100%", xs: "100%" },
                      padding: { md: "30px", xs: "16px" },
                      borderRadius: "5px",
                    }}
                  >
                    <Stack rowGap={{ md: 0, xs: 0 }}>
                      <Box>
                        <Typography variant="headerMenu">Personal Info</Typography>
                      </Box>
                      <Divider
                        sx={{
                          width: "100%",
                          my: { md: 2, xs: 1 },
                        }}
                      />
                      <Stack rowGap={{ md: 4, xs: "4px" }}>
                        <Stack
                          direction={{ md: "row", xs: "column" }}
                          rowGap={{ xs: "4px", md: 0 }}
                          columnGap={4}
                        >
                          <TypographyText label="User Name" value={user.username} />
                          <TypographyText label="legal Name" value={user?.legalName} />
                          <TypographyText
                            label="Mobile Number"
                            value={user.mobileNumber}
                          />
                        </Stack>
                        <Stack
                          direction={{ md: "row", xs: "column" }}
                          rowGap={{ xs: "4px", md: 0 }}
                          columnGap={4}
                        >
                          <TypographyText label="Email" value={user.emailId} />
                          <TypographyText
                            label="Date Of Birth"
                            value={moment.unix(user.dob).format("DD-MM-YYYY")}
                          />
                          <TypographyText
                            label="Citizenship"
                            value={user.citizenShip}
                          />
                        </Stack>
                      </Stack>
                    </Stack>
                  </Stack>
                </Stack>
              </CardContent>
            </Card>
          )}
          {isSmallScreen ? (
            <Accordion
              expanded={profileSectionsExpanded.address}
              onChange={(_, expanded) =>
                setProfileSectionsExpanded((prev) => ({ ...prev, address: expanded }))
              }
              sx={{ m: "12px auto", borderRadius: 2, overflow: "hidden" }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="headerMenu">Address Info</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ pt: 0 }}>
                <Divider sx={{ width: "100%", mb: 1 }} />
                <Stack direction={{ md: "row", xs: "column" }} columnGap={6}>
                  <Stack sx={{ width: { md: "50%" } }}>
                    <Typography
                      variant="headerTab"
                      sx={{ fontWeight: "400", mb: { md: 2, xs: 1 } }}
                    >
                      Correspondence Address
                    </Typography>
                    <Stack rowGap={{ md: 2, xs: "4px" }}>
                      <Stack direction={{ xs: "column" }} rowGap={{ xs: "4px", md: 2 }}>
                        <TypographyText
                          label="Flat No,House No"
                          value={user?.userAddress?.flatNo}
                          isRow={true}
                        />
                        <TypographyText
                          label="Area,Street"
                          value={user?.userAddress?.area}
                          isRow={true}
                        />
                        <TypographyText
                          label="Landmark"
                          value={user?.userAddress?.landmark}
                          isRow={true}
                        />
                      </Stack>
                      <Stack direction={{ xs: "column" }} rowGap={{ xs: "4px", md: 2 }}>
                        <TypographyText
                          label="Town/City"
                          value={user?.userAddress?.town}
                          isRow={true}
                        />
                        <TypographyText
                          label="State"
                          value={user?.userAddress?.state}
                          isRow={true}
                        />
                        <TypographyText
                          label="Pincode"
                          value={user?.userAddress?.pincode}
                          isRow={true}
                        />
                      </Stack>
                    </Stack>
                  </Stack>

                  <Stack sx={{ width: { md: "50%" }, mt: { xs: 2, md: 0 } }}>
                    <Typography variant="headerTab" sx={{ mb: { md: 2, xs: 1 } }}>
                      Aadhar Address
                    </Typography>

                    <Stack rowGap={3}>
                      <Stack rowGap={{ xs: "4px", md: 2 }}>
                        <Stack
                          direction={{ xs: "column" }}
                          rowGap={{ xs: "4px", md: 2 }}
                          columnGap={4}
                        >
                          <TypographyText
                            label="Flat No,House No"
                            value={user?.aadharAddress?.flatNo || "-"}
                            isRow={true}
                          />
                          <TypographyText
                            label="Area,Street"
                            value={user?.aadharAddress?.area || "-"}
                            isRow={true}
                          />
                          <TypographyText
                            label="Landmark"
                            value={user?.aadharAddress?.landmark || "-"}
                            isRow={true}
                          />
                        </Stack>
                        <Stack
                          direction={{ xs: "column" }}
                          rowGap={{ xs: "4px", md: 2 }}
                          columnGap={4}
                        >
                          <TypographyText
                            label="Town/City"
                            value={user?.aadharAddress?.town || "-"}
                            isRow={true}
                          />
                          <TypographyText
                            label="State"
                            value={user?.aadharAddress?.state || "-"}
                            isRow={true}
                          />
                          <TypographyText
                            label="Pincode"
                            value={user?.aadharAddress?.pincode || "-"}
                            isRow={true}
                          />
                        </Stack>
                      </Stack>
                    </Stack>
                  </Stack>
                </Stack>
              </AccordionDetails>
            </Accordion>
          ) : (
            <Card sx={{ m: "12px auto" }}>
              <CardContent sx={{ p: "0px !important" }}>
                <Stack
                  sx={{
                    padding: { md: "30px", xs: "16px" },
                    borderRadius: "5px",
                  }}
                >
                  <Typography variant="headerMenu">Address Info</Typography>
                  <Divider
                    sx={{
                      width: "100%",
                      my: { md: 2, xs: 1 },
                    }}
                  />
                  <Stack direction={{ md: "row", xs: "column" }} columnGap={6}>
                    <Stack sx={{ width: { md: "50%" } }}>
                      <Typography
                        variant="headerTab"
                        sx={{ fontWeight: "400", mb: { md: 2, xs: 1 } }}
                      >
                        Correspondence Address
                      </Typography>
                      <Stack rowGap={{ md: 2, xs: "4px" }}>
                        <Stack
                          direction={{ xs: "column" }}
                          rowGap={{ xs: "4px", md: 2 }}
                        >
                          <TypographyText
                            label="Flat No,House No"
                            value={user?.userAddress?.flatNo}
                            isRow={true}
                          />
                          <TypographyText
                            label="Area,Street"
                            value={user?.userAddress?.area}
                            isRow={true}
                          />
                          <TypographyText
                            label="Landmark"
                            value={user?.userAddress?.landmark}
                            isRow={true}
                          />
                        </Stack>
                        <Stack
                          direction={{ xs: "column" }}
                          rowGap={{ xs: "4px", md: 2 }}
                        >
                          <TypographyText
                            label="Town/City"
                            value={user?.userAddress?.town}
                            isRow={true}
                          />
                          <TypographyText
                            label="State"
                            value={user?.userAddress?.state}
                            isRow={true}
                          />
                          <TypographyText
                            label="Pincode"
                            value={user?.userAddress?.pincode}
                            isRow={true}
                          />
                        </Stack>
                      </Stack>
                    </Stack>
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={{ borderColor: "#F7F7F7", borderWidth: "8px" }}
                    />
                    <Stack sx={{ width: { md: "50%" } }}>
                      <Typography
                        variant="headerTab"
                        sx={{ mb: { md: 2, xs: 1 } }}
                      >
                        Aadhar Address
                      </Typography>

                      <Stack rowGap={3}>
                        <Stack rowGap={{ xs: "4px", md: 2 }}>
                          <Stack
                            direction={{ xs: "column" }}
                            rowGap={{ xs: "4px", md: 2 }}
                            columnGap={4}
                          >
                            <TypographyText
                              label="Flat No,House No"
                              value={user?.aadharAddress?.flatNo || "-"}
                              isRow={true}
                            />
                            <TypographyText
                              label="Area,Street"
                              value={user?.aadharAddress?.area || "-"}
                              isRow={true}
                            />
                            <TypographyText
                              label="Landmark"
                              value={user?.aadharAddress?.landmark || "-"}
                              isRow={true}
                            />
                          </Stack>
                          <Stack
                            direction={{ xs: "column" }}
                            rowGap={{ xs: "4px", md: 2 }}
                            columnGap={4}
                          >
                            <TypographyText
                              label="Town/City"
                              value={user?.aadharAddress?.town || "-"}
                              isRow={true}
                            />
                            <TypographyText
                              label="State"
                              value={user?.aadharAddress?.state || "-"}
                              isRow={true}
                            />
                            <TypographyText
                              label="Pincode"
                              value={user?.aadharAddress?.pincode || "-"}
                              isRow={true}
                            />
                          </Stack>
                        </Stack>
                      </Stack>
                    </Stack>
                  </Stack>
                </Stack>
              </CardContent>
            </Card>
          )}

          <Card sx={{ m: "12px auto" }}>
            <CardContent sx={{ p: "0px !important" }}>
              <Stack direction={{ md: "row", xs: "column" }} spacing={2}>
                <Stack
                  sx={{
                    width: { md: "100%", xs: "100%" },
                    padding: { md: "30px", xs: "16px" },
                    borderRadius: "5px",
                  }}
                >
                  <Stack>
                    <Box>
                      <Typography variant="headerMenu">Bank Info</Typography>
                    </Box>
                    <Divider
                      sx={{
                        width: "100%",
                        my: { md: 2, xs: 1 },
                      }}
                    />
                    <BankAccount
                      entityId={user._id}
                      panCardNumber={user.panCardNumber}
                      entityType={"PERSONAL"}
                      status={user?.status}
                    />
                  </Stack>
                </Stack>
              </Stack>
            </CardContent>
          </Card>
          <Card sx={{ m: '12px auto' }}>
            <CardContent sx={{ p: '0px !important' }}>
              {user?.status === "APPROVED" && <Box sx={{ padding: { md: "30px", xs: "10px" }, borderRadius: "5px" }}>

                <BlockchainSection
                  availableBlockchainAccounts={availableBlockchainAccounts}
                  availablePolygonBlockchainAccounts = {availablePolygonBlockchainAccounts}
                  availableMstBlockchainAccounts = {availableMstBlockchainAccounts}
                  setBlockchainAccountModal={setBlockchainAccountModal}
                  user={user}
                  dispatch={dispatch}
                />
              </Box>}
            </CardContent>
          </Card>
          <Button
            variant="outlined"
            color="error"
            size="small"
            sx={{
              padding: "10px 12px !important",
              display: { xs: "inline-flex", sm: "none" },
            }}
            style={{ marginBottom: "20px" }}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Stack>
      ) : (
        <>
          <Box marginTop={"-110px"}>
            <Skeleton width={"100%"} height={400} />
          </Box>
          <Box marginTop={"-110px"}>
            <Skeleton width={"100%"} height={400} />
          </Box>
          <Box marginTop={"-110px"}>
            <Skeleton width={"100%"} height={400} />
          </Box>
        </>
      )}
    </>
  );
}

function BlockchainSection({ availableBlockchainAccounts,availablePolygonBlockchainAccounts, availableMstBlockchainAccounts, user, dispatch, setBlockchainAccountModal }) {
  const { enqueueSnackbar } = useSnackbar();
  const [network , setNetwork] = useState('algorand')
  const [activeNetworkTab, setActiveNetworkTab] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPolygonIndex, setCurrentPolygonIndex] = useState(0);
  const [currentMstIndex, setCurrentMstIndex] = useState(0);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [primaryOpen, setPrimaryOpen] = useState(false);
  const [dltAccountId, setDltAccountId] = useState();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuAccount, setMenuAccount] = useState(null);
  
  const handlePrimary = async () => {
    let res;
    if(network == 'algorand')
     res = await userServices.updatePrimaryDLTAccount({ entityId: user?._id, dltWalletId: dltAccountId, entityType: "INVESTOR" });
    else if (network === 'polygon')
      res = await userServices.updatePrimaryDLTPolygonAccount({ entityId: user?._id, dltWalletId: dltAccountId, entityType: "INVESTOR" });
    else if (network === 'mst')
      res = await userServices.makePrimaryDLTMSTAccount({ entityId: user?._id, dltWalletId: dltAccountId, entityType: "INVESTOR" });
    if (res && res.success) {
      dispatch(saveUser(res.data));
    }
  };

  const handleRemove = async () => {
    let res;
    if(network == 'algorand')
      res = await userServices.removeDLTAccount({ entityId: user?._id, dltWalletId: dltAccountId, entityType: "INVESTOR" });
    else if (network === 'polygon')
      res = await userServices.removeDLTPolygonAccount({ entityId: user?._id, dltWalletId: dltAccountId, entityType: "INVESTOR" });
    else if (network === 'mst')
      res = await userServices.removeDLTMSTAccount({ entityId: user?._id, dltWalletId: dltAccountId, entityType: "INVESTOR" });
    if (res && res.success) {
      dispatch(saveUser(res.data));
      enqueueSnackbar("DLT Account Deleted Successfully!", {
        variant: "success",
        anchorOrigin: { horizontal: "right", vertical: "top" },
        autoHideDuration: 3000,
      });
    } else
      enqueueSnackbar(
        "This DLT Account is Holding Some Digital Assets in it. Please Contact RealX Admin for More Information!",
        {
          variant: "error",
          anchorOrigin: { horizontal: "center", vertical: "bottom" },
          autoHideDuration: 9000,
        }
      );
  };

  const handleDLTCreationStatus = async (investorId, status) => {
    const res = await userServices.updateDLTCreationStatus({
      investorId,
      status,
    });
    if (res && res.success) {
      dispatch(saveUser(res.data));
    }
  };

  const copyUrl = (account) => {
    navigator.clipboard.writeText(account);
    enqueueSnackbar("Copied to Clickboard", { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, autoHideDuration: 800 })
  };

  const setAccountIndex = (networkType, index) => {
    if (networkType === "polygon") setCurrentPolygonIndex(index);
    else if (networkType === "mst") setCurrentMstIndex(index);
    else setCurrentIndex(index);
  };

  const getSelectedPublicAddress = () => {
    if (network === "polygon") return availablePolygonBlockchainAccounts[currentPolygonIndex]?.publicAddress;
    if (network === "mst") return availableMstBlockchainAccounts[currentMstIndex]?.publicAddress;
    return availableBlockchainAccounts[currentIndex]?.publicAddress;
  };

  const networkSections = [
    { key: "polygon", name: "Polygon", accounts: availablePolygonBlockchainAccounts, networkType: "polygon" },
    { key: "mst", name: "MST", accounts: availableMstBlockchainAccounts, networkType: "mst" },
    { key: "algorand", name: "Algorand", accounts: availableBlockchainAccounts, networkType: "algorand" },
  ].filter((section) => section.accounts?.length > 0);

  useEffect(() => {
    if (activeNetworkTab >= networkSections.length && networkSections.length > 0) {
      setActiveNetworkTab(0);
    }
  }, [activeNetworkTab, networkSections.length]);

  const activeSection = networkSections[activeNetworkTab];

  const handleMenuOpen = (event, account, index, networkType) => {
    setMenuAnchorEl(event.currentTarget);
    setMenuAccount({ account, index, networkType });
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setMenuAccount(null);
  };

  const handleMenuPrimary = () => {
    if (!menuAccount) return;
    const { account, index, networkType } = menuAccount;
    setAccountIndex(networkType, index);
    setNetwork(account.network || networkType);
    setPrimaryOpen(true);
    setDltAccountId(account._id);
    handleMenuClose();
  };

  const handleMenuDelete = () => {
    if (!menuAccount) return;
    const { account, index, networkType } = menuAccount;
    setAccountIndex(networkType, index);
    setNetwork(account.network || networkType);
    setDeleteOpen(true);
    setDltAccountId(account._id);
    handleMenuClose();
  };

  const renderAccountList = (accounts, networkType = "algorand") => (
    (accounts[0] !== undefined && accounts.length >= 1) ? (
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" },
          gap: 1.5,
        }}
      >
      {accounts
        .sort((a, b) => (b.isPrimary ? 1 : -1) - (a.isPrimary ? 1 : -1))
        .map((account, index) => (
          <Box
            key={account._id}
            sx={{
              p: { xs: 1.25, sm: 1.5 },
              borderRadius: 2,
              boxShadow: 1,
              width: "100%",
              minWidth: 0,
            }}
          >
            <Stack spacing={1}>
              <Stack direction="row" alignItems="flex-start" justifyContent="space-between" gap={1}>
                <Typography sx={{ fontWeight: 600, fontSize: 12, wordBreak: "break-word", flex: 1, minWidth: 0 }}>
                  #{index + 1}. {account?.name?.slice(0, 30) || "DLT Account"}
                </Typography>
                <Stack direction="row" alignItems="center" spacing={0.5} sx={{ flexShrink: 0 }}>
                  {account.isPrimary && (
                    <Typography sx={{
                      color: "white",
                      background: "#21ab37",
                      padding: "2px 15px !important",
                      fontSize: "12px !important",
                      border: "1px solid #21ab37",
                      borderRadius: "8px",
                      whiteSpace: "nowrap",
                      lineHeight: 1.4,
                    }}>
                      Primary Account
                    </Typography>
                  )}
                  {!account.isPrimary && (
                    <IconButton
                      size="small"
                      sx={{ p: 0.25 }}
                      onClick={(e) => handleMenuOpen(e, account, index, networkType)}
                    >
                      <MoreVertIcon sx={{ fontSize: 18, color: "text.secondary" }} />
                    </IconButton>
                  )}
                </Stack>
              </Stack>

              <Stack sx={{marginBottom: "10px !important"}} direction={{ xs: "column", sm: "row" }} gap={{ xs: 0.75, sm: 1.5 }}>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography sx={{ display: "block", mb: 0.25, fontSize: "15px !important", color: "#B0B0B0" }}>Address</Typography>
                  <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography sx={{ fontFamily: "monospace", fontSize: "12px !important", wordBreak: "break-all", lineHeight: 1.4 }}>
                      ...{account.publicAddress?.slice(-20)}
                    </Typography>
                    <IconButton
                      size="small"
                      sx={{ p: 0.25, flexShrink: 0 }}
                      onClick={() => copyUrl(account.publicAddress)}
                    >
                      <CustomIcon name="copy" sx={{ bgcolor: "#333", cursor: "pointer", width: 12, height: 12 }} />
                    </IconButton>
                  </Stack>
                </Box>
                {account?.created_at && (
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography sx={{ display: "block", mb: 0.25, fontSize: "15px !important", color: "#B0B0B0" }}>Created</Typography>
                    <Typography sx={{ fontSize: "12px !important", lineHeight: 1.4 }}>
                      {moment(account.created_at).format("DD MMM YYYY")}
                    </Typography>
                  </Box>
                )}
              </Stack>

              <Button
                variant="outlined"
                size="small"
                fullWidth
                endIcon={<OpenInNewIcon sx={{ fontSize: 13 }} />}
                sx={{
                  fontSize: 11,
                  py: "4px !important",
                  textTransform: "none",
                  borderColor: "divider",
                  color: "text.primary",
                  "&:hover": { borderColor: "primary.main", color: "primary.main", bgcolor: "transparent" },
                }}
                onClick={() => {
                  const explorerUrl = getAccountLink(networkType, account.publicAddress);
                  window.open(explorerUrl, "_blank");
                }}
              >
                {getExplorerButtonText(networkType)}
              </Button>
            </Stack>
          </Box>
        ))}
      </Box>
    ) : <Typography variant="subtitle1">No accounts available</Typography>
  );

  return (
    <Stack spacing={3}>
      <AreYouSureModal
        open={primaryOpen}
        setOpen={setPrimaryOpen}
        handleYes={handlePrimary}
        message={"Are You Sure About Updating your Primary DLT Account?"}
        publicAddress={getSelectedPublicAddress()}
        publicAddressMessage={"Your New Primary DLT Account Address"}
      />
      <AreYouSureModal
        open={deleteOpen}
        setOpen={setDeleteOpen}
        handleYes={handleRemove}
        message={"Are You Sure About Permanently Deleting this DLT Account?"}
        note={"This action can not be undo!"}
        publicAddress={getSelectedPublicAddress()}
        publicAddressMessage={"DLT Account Address To Be Removed"}
      />

      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            minWidth: "unset !important",
            width: "max-content",
            "& .MuiMenuItem-root": {
              fontSize: 11,
              py: 0.75,
              px: 1.25,
              minHeight: "auto",
            },
          },
        }}
      >
        <MenuItem sx={{fontSize: "14px !important", paddingY: "3px !important"}} onClick={handleMenuPrimary}>Make Primary</MenuItem>
        <MenuItem sx={{fontSize: "14px !important", paddingY: "3px !important", color: "error.main"}} onClick={handleMenuDelete}>Delete Account</MenuItem>
      </Menu>

      <Typography variant="headerMenu">
        Available Blockchain Accounts
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: "text.secondary", mb: 1, fontSize: "8px" }}
      >
        Note: Maximum 5 DLT wallets are allowed.
      </Typography>

      {networkSections.length > 0 && (
        <>
          {networkSections.length > 1 && (
            <Tabs
              tabs={networkSections.map((section) => ({ name: section.name }))}
              activeTab={activeNetworkTab}
              onClick={setActiveNetworkTab}
            />
          )}

          <Stack spacing={1} sx={{ mt: networkSections.length > 1 ? 1 : 0 }}>
            {activeSection && renderAccountList(activeSection.accounts, activeSection.networkType)}
          </Stack>
        </>
      )}

      <Stack flexDirection="row" justifyContent="center" mt={2} gap={1}>
        <Button
          onClick={() =>
            user?.walletInfo?.isAllowedToCreateDLT == "APPROVED"
              ? setBlockchainAccountModal(true)
              : handleDLTCreationStatus(user?._id, "PENDING")
          }
          variant="contained"
          sx={{ width: "max-content", py: "10px !important" }}
          disabled={
            availableBlockchainAccounts?.length +
              availablePolygonBlockchainAccounts?.length +
              availableMstBlockchainAccounts?.length >=
              5 || user?.walletInfo?.isAllowedToCreateDLT == "PENDING"
          }
        >
          {user?.walletInfo?.isAllowedToCreateDLT == "APPROVED"
            ? "Create a New DLT Account"
            : user?.walletInfo?.isAllowedToCreateDLT == "PENDING"
            ? "Request Submitted to RealX Admin"
            : "Request to Create a New DLT Account"}
        </Button>

        {user?.walletInfo?.isAllowedToCreateDLT == "PENDING" && (
          <Button
            variant="contained"
            sx={{ py: "7px !important" }}
            onClick={() => handleDLTCreationStatus(user?._id, "CREATED")}
          >
            Cancel Request
          </Button>
        )}
      </Stack>
    </Stack>
  );
}

const EntityMenu = ({
  anchorEl,
  setAnchorEl,
  getallFamilyMember,
  hufHeadDetails,
  familyMemberDetail,
  trustDetails,
}) => {
  const [showHufQues, setShowHufQues] = useState(false);
  const [showTrustQues, setShowTrustQues] = useState(false);
  const [createFamilyMember, setCreateFamilyMember] = useState(false);
  const [huforTrust, setHuforTrust] = useState(false);

  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleHufClose = () => {
    setShowHufQues(false);
  };
  const handleTrustClose = () => {
    setShowTrustQues(false);
  };

  const handleCreateFamilyMember = () => {
    setCreateFamilyMember(false);
  };

  return (
    <>
      <HufHeadAndTrust
        hufAndTurst={huforTrust}
        open={showHufQues}
        handleClose={handleHufClose}
      />
      <HufHeadAndTrust
        hufAndTurst={huforTrust}
        open={showTrustQues}
        handleClose={handleTrustClose}
      />
      <AddFamilyMember
        open={createFamilyMember}
        handleClose={handleCreateFamilyMember}
        getallFamilyMember={getallFamilyMember}
      />
      <Menu
        PaperProps={{
          sx: {
            minWidth: "fit-content !important",
            bgcolor: " #bdbdbd mportant",
            color: "#111",
          },
        }}
        sx={{
          transform: "translateX(30px)",
        }}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {hufHeadDetails.length < 1 && (
          <MenuItem onClick={handleClose}>
            <Stack direction={"row"} spacing={1.5}>
              <Typography
                variant="body2"
                onClick={() => {
                  setShowHufQues(true);
                  setHuforTrust(true);
                }}
              >
                Create an Huf
              </Typography>
            </Stack>
          </MenuItem>
        )}
        {familyMemberDetail.length < 2 && (
          <MenuItem onClick={handleClose}>
            <Stack direction={"row"} spacing={1.5}>
              <Typography
                variant="body2"
                onClick={() => setCreateFamilyMember(true)}
              >
                Add Family Member
              </Typography>
            </Stack>
          </MenuItem>
        )}
        {trustDetails.length < 1 && (
          <MenuItem onClick={handleClose}>
            <Stack direction={"row"} spacing={1.5}>
              <Typography
                variant="body2"
                onClick={() => {
                  setShowTrustQues(true);
                  setHuforTrust(false);
                }}
              >
                Add Trust
              </Typography>
            </Stack>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
